import React, { createContext, useContext, useState, useMemo } from "react";

const QuoteContext = createContext(null);

export const QuoteProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [preselected, setPreselected] = useState("");
  const [preselectedBrand, setPreselectedBrand] = useState("");

  const openQuote = (service = "", brand = "") => {
    setPreselected(service);
    setPreselectedBrand(brand);
    setOpen(true);
  };

  const value = useMemo(
    () => ({ open, setOpen, openQuote, preselected, preselectedBrand }),
    [open, preselected, preselectedBrand]
  );

  return (
    <QuoteContext.Provider value={value}>{children}</QuoteContext.Provider>
  );
};

export const useQuote = () => useContext(QuoteContext);
